
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import BaseLayout from "@components/BaseLayout";
import PageNavigation from "@components/common/PageNavigation";
import ErrorPage from "@components/ErrorPage";
import ContactForm from "@components/process/ContactForm";
import { loadCurrentProcessAction, ProcessActionTypes } from "@redux/actions/processes";
import { AppState } from "@redux/reducer";
import { selectCurrentProcess, selectSingleEntityUsecaseState } from "@redux/reducer/data";
import { EntityType } from "@redux/reduxTypes";
import { Routes } from "@services/routes";
/**
 * This page provides a form to let users contact the processmanager or admin
 */
const ContactPage = (): JSX.Element => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();
    const processRequest = useSelector((state: AppState) => selectSingleEntityUsecaseState(state, EntityType.Process, ProcessActionTypes.LoadCurrentProcess));
    const currentProcess = useSelector(selectCurrentProcess);
    useEffect(() => {
        if (!currentProcess) {
            dispatch(loadCurrentProcessAction());
        }
    }, []);
    // if process could not be loaded and an error returned, display the error
    if (processRequest?.loadingError) {
        return <ErrorPage statusCode={404} error={processRequest?.loadingError}/>;
    }
    // if the process could not be loaded, no error returned, but null returned, display a message like no process on the platform
    if (processRequest?.loaded && !currentProcess) {
        return <ErrorPage statusCode={404} error={"validate.process.noProcessCouldBeFound"}/>;
    }
    return <BaseLayout pageTitle={t("page.contact.title")}>
    <Row>
      <Col sm={6}>
        <p>{t("page.contact.intro")}</p>
        <ContactForm />
      </Col>
    </Row>
    <Row>
      <Col>
        <PageNavigation leftNavigation={{ href: Routes.Marketplace, title: "goto.marketplace" }} className=""/>
      </Col>
    </Row>
  </BaseLayout>;
};
export default ContactPage;

    async function __Next_Translate__getStaticProps__18c4f517123__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/contact',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c4f517123__ as getStaticProps }
  